<template>
<div class="chapter">
<div class="inner_page">
<p class="cp-break" id="copy"><a id="piv"></a>Copyright © 2022 by The University Press of Kentucky</p>
<p class="cp-spaced">Scholarly publisher for the Commonwealth, serving Bellarmine University, Berea College, Centre College of Kentucky, Eastern Kentucky University, The Filson Historical Society, Georgetown College, Kentucky Historical Society, Kentucky State University, Morehead State University, Murray State University, Northern Kentucky University, Spalding University, Transylvania University, University of Kentucky, University of Louisville, and Western Kentucky University.</p>
<p class="cp">All rights reserved.</p>
<p class="cp-spaced"><i>Editorial and Sales Offices:</i> The University Press of Kentucky</p>
<p class="cp">663 South Limestone Street, Lexington, Kentucky 40508-4008</p>
<p class="cp"><a class="www" href="http://www.kentuckypress.com" target="_blank">www.kentuckypress.com</a></p>
<p class="cp-spaced">The Library of Congress has assigned the following LCCN to the 1989 edition: 88021642.</p>
<p class="cp">Previous edition published in 2012 by Open Road Integrated Media.</p>
<p class="cp-spaced">ISBN 978-0-8131-9544-5 (pbk. : alk. paper)</p>
<p class="cp">ISBN 978-0-8131-9599-5 (epub)</p>
<p class="cp-spaced">This book is printed on acid-free paper meeting the requirements of the American National Standard for Permanence in Paper for Printed Library Materials.</p>
<p class="cp-infin"><img alt="image" src="images/infin.png"/></p>
<p class="cp">Manufactured in the United States of America</p>
<p class="cp-spaced"><img alt="image" src="images/logo.png" style="vertical-align:-0.5em;"/> Member of the Association of University Presses</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// copyright.vue?31686ade